import { fetchAuthSession } from 'aws-amplify/auth';

import type { AuthSession } from '@aws-amplify/auth';

let inflightRefresh: Promise<AuthSession> | null = null;

export const refreshAuthSession = (): Promise<AuthSession> => {
  if (inflightRefresh) return inflightRefresh;

  inflightRefresh = fetchAuthSession({ forceRefresh: true }).finally(() => {
    inflightRefresh = null;
  });

  return inflightRefresh;
};
